module.exports = __webpack_public_path__ + "img/tma-auth-image.ce189075.svg";